module.exports = __webpack_public_path__ + "static/img/upgradePopupBg.27d648b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imageSaver/upgradePopupBg.png
// module id = Dn/J
// module chunks = 2